// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const buttonClasses = {
  group: "qui-button-group",
  icon: "qui-button__icon",
  root: "qui-button__root",
} as const
